export const Format = {
   CommaSeparatedList(value){
       return value ? value.replace(/,/g, ', ') : '';
  }
}   
export default Format;